<template xmlns:v-hammer="http://www.w3.org/1999/xhtml">
    <div ref="carouselWrapper" v-bind:class="[{ active: overflowing }, 'carousel-wrapper']">
        <div v-if="overflowing" class="carousel-nav">
            <a  v-show="(loop || left !== 0 || left === ($refs.carousel.offsetWidth - $refs.carousel.scrollWidth)) && $refs.carousel.childNodes.length > 1"
               class="control-button prev cursor-pointer" @click="navigateLeft"></a>
            <a  v-show="(loop || left === 0 || left !== ($refs.carousel.offsetWidth - $refs.carousel.scrollWidth)) && $refs.carousel.childNodes.length > 1"
               class="control-button next cursor-pointer" @click="navigateRight"></a>
        </div>
        <div ref="carousel" class="carousel"
             :style="{left: left != null ? left +'px' : 'auto'}">
            <slot></slot>
        </div>
    </div>
</template>
<script>


    export default {
        name: "carousel",
        props: {
            initial: {
                type: Number,
                default: 0
            },
            loop: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                overflowing: false,
                left: null
            }
        },
        created() {
            window.addEventListener("resize", this.initialize);
        },
        destroyed() {
            window.removeEventListener("resize", this.initialize);
        },
        mounted: function () {
            this.initialize();
        },
        methods: {
            initialize() {
                this.$nextTick(function () {
                    let carousel = this.$refs.carousel;

                    if (carousel.scrollWidth > carousel.offsetWidth) {
                        this.left = this.calculateInitialPosition(this.initial);
                        this.overflowing = true;
                    } else {
                        this.overflowing = false;
                        this.left = null;
                    }

                });
            },
            handleSwipe(e) {
                e.type === "swipeleft" ? this.navigateRight() : this.navigateLeft();
            },
            calculateInitialPosition(idx) {

                let carousel = this.$refs.carousel;

                let distanceToBeScrolled = 0,
                    scrolledElementsTotalWidth = 0,
                    contentNodes = carousel.childNodes;

                for (let i = 0; i < contentNodes.length; i++) {
                    let contentNode = contentNodes[i],
                        elementStyle = contentNode.currentStyle || window.getComputedStyle(contentNode),
                        slideTotalWidth = (parseInt(elementStyle.marginRight) + parseInt(elementStyle.marginLeft) + contentNode.scrollWidth),
                        combinedWidth = scrolledElementsTotalWidth + slideTotalWidth;

                    if (idx === i) {
                        distanceToBeScrolled = scrolledElementsTotalWidth;
                        break;
                    }

                    scrolledElementsTotalWidth = combinedWidth;

                }

                return distanceToBeScrolled * -1;
            },
            navigateRight() {

                let carousel = this.$refs.carousel;

                if (carousel) {

                    if(this.loop && this.left === (carousel.offsetWidth - carousel.scrollWidth)) {
                        this.left = 0;
                        return;
                    }


                    let offsetLeft = Math.abs(carousel.offsetLeft),
                        visiblePart = carousel.scrollWidth - offsetLeft;

                    if (visiblePart > carousel.offsetWidth) {

                        let distanceToBeScrolled = (offsetLeft + carousel.offsetWidth),
                            scrolledElementsTotalWidth = 0,
                            contentNodes = carousel.childNodes;

                        if (carousel.scrollWidth - distanceToBeScrolled < carousel.offsetWidth) {

                            // scroll to end
                            this.left = (carousel.offsetWidth - carousel.scrollWidth);
                        } else {
                            for (let i = 0; i < contentNodes.length; i++) {
                                let contentNode = contentNodes[i],
                                    elementStyle = contentNode.currentStyle || window.getComputedStyle(contentNode),
                                    slideTotalWidth = (parseInt(elementStyle.marginRight) + parseInt(elementStyle.marginLeft) + contentNode.scrollWidth),
                                    combinedWidth = scrolledElementsTotalWidth + slideTotalWidth;

                                if (combinedWidth > distanceToBeScrolled) {
                                    distanceToBeScrolled = scrolledElementsTotalWidth;
                                    break;
                                }

                                scrolledElementsTotalWidth = combinedWidth;

                            }

                            this.left = distanceToBeScrolled * -1;
                        }

                    }
                }
            },
            navigateLeft() {
                let carousel = this.$refs.carousel;

                if (carousel) {

                    let offsetLeft = Math.abs(carousel.offsetLeft);

                    if(this. loop && offsetLeft === 0) {
                        this.left = (carousel.offsetWidth - carousel.scrollWidth);
                        return;
                    }

                    if (carousel.offsetLeft < 0) {

                        let distanceToBeScrolled = (offsetLeft - carousel.offsetWidth),
                            scrolledElementsTotalWidth = 0,
                            contentNodes = carousel.childNodes;

                        if (distanceToBeScrolled <= 0) {
                            this.left = 0;
                        } else {

                            for (let i = 0; i < contentNodes.length; i++) {
                                let contentNode = contentNodes[i],
                                    elementStyle = contentNode.currentStyle || window.getComputedStyle(contentNode);

                                scrolledElementsTotalWidth = scrolledElementsTotalWidth + (parseInt(elementStyle.marginRight) + parseInt(elementStyle.marginLeft) + contentNode.scrollWidth);

                                if (scrolledElementsTotalWidth >= distanceToBeScrolled) {
                                    distanceToBeScrolled = scrolledElementsTotalWidth;
                                    break;
                                }


                            }
                            this.left = distanceToBeScrolled * -1;
                        }
                    }
                }
            }
        },
        computed: {
            carouselEl() {
                return this.$refs.carousel;
            },

        }

    }
</script>
<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";


    .carousel-wrapper {
        overflow-x: hidden;
        @include media-breakpoint-down(md) {
            overflow-x: scroll;
        }

        position: relative;

        .carousel-nav {
            @include media-breakpoint-down(md) {
                display: none;
            }

            .control-button {
                position: absolute;
                width: 40px;
                height: 100%;
                z-index: 99;

                &[aria-disabled=true] {
                    display: none;
                }

                &.prev {
                    left: 0;
                    background: url("~@shared/_assets/img/slider-arrow-left.png") no-repeat center center;
                }

                &.next {
                    right: 0;
                    background: url("~@shared/_assets/img/slider-arrow-right.png") no-repeat center center;
                }
            }
        }

        .carousel {
            display: flex;
            transition: left ease-out 0.5s;
            position: relative;
            text-align: center;
            justify-content: center;
        }

        &.active .carousel {
            justify-content: flex-start;
        }
    }


</style>